import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import BrandMark from '../../components/BrandMark';

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {/* the same arrangement as ScreenSizeWarning: the mark, then what went wrong */}
      <BrandMark width={42} height={50} style={{ marginBottom: 19 }} />
      <Typography variant="h1">{t('errors.notFound')}</Typography>
    </Box>
  );
};

export default NotFoundPage;
